export const normalizeEmail = (value, previousValue) => {
  if (!value) {
    return value
  }
  return value.replace(/ /g, '')
}
